import { APIEndpoint } from ".";

export const login = async (email: string, password: string) => {
  return fetch(APIEndpoint + "/users/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: email, password: password }),
  })
    .then((res) => res.json())
    .then((res) => {
      if (res.success === true) {
        localStorage.setItem("token", res.token);
        return res;
      } else {
        return res;
      }
    })
    .catch((e) => {
      console.log("API Call, error getting profile", e);
    });
};
